import {
  base_colorAction,
  base_colorAlert,
  base_colorAlertHover,
  base_contentBackground,
} from 'ext-ui/style/colors'
import { spacing } from 'ext-ui/style/spacing'
import { font_md, fontH2, fontRegular } from 'ext-ui/style/typography'
import { css } from 'styled-components'

export default css`
  .overlay {
    align-items: flex-start;
    padding-top: ${spacing(20)};
  }

  .panel {
    gap: ${spacing(5)};
    margin: 0 auto;
    max-height: calc(100vh - ${spacing(40)});
    max-width: ${spacing(125)};
  }

  .title {
    ${fontH2};
  }

  .description {
    ${fontRegular};
  }

  .body {
    max-width: 100%;
    overflow-y: auto;
    width: 100%;
  }

  .footer {
    margin-top: ${spacing(5)};
  }

  .close {
    background: ${base_contentBackground};
    border-radius: 50%;
    height: ${spacing(10)};
    right: 0;
    top: -${spacing(13)};
    width: ${spacing(10)};
  }

  .code-input-digit {
    ${font_md};
    height: ${spacing(12)};

    &.filled {
      border-color: ${base_colorAction};
    }
  }

  /* The feature's filled-state blue must not outrank CodeInput's error state.
     Keep the visible severe border in sync with the announced error text. */
  .CodeInput.error .code-input-digit {
    border-color: ${base_colorAlert};

    &:hover {
      border-color: ${base_colorAlertHover};
    }
  }

  .mfa-step-up-form {
    display: flex;
    flex-direction: column;
    gap: ${spacing(4)};
  }

  .mfa-step-up-actions {
    display: flex;
    flex-direction: column;
    gap: ${spacing(5)};
    width: 100%;

    button {
      width: 100%;
    }
  }

  @media (max-width: ${spacing(141)}) {
    .overlay {
      padding-left: ${spacing(4)};
      padding-right: ${spacing(4)};
    }
  }
`
